import PhoneFooter from '../../../public/svg_images/phone-footer.svg';

function PhoneFooterrSvg() {
  return (
    <div className='bg-[#04BBDC] w-[29px] h-[26px] flex items-center justify-center rounded-md'>
    <PhoneFooter
      width={10}
      height={10}
      role="img" aria-label="Call now" 
    />
    </div>
  );
}

export default PhoneFooterrSvg;